// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var ReportPartSelectionStore = require('logic/Izenda.ReportPartSelectionStore');
  var ReportPartSelectionConstants = require('logic/data/Izenda.ReportPartSelectionConstants');
  var withHandlers = require('recompose').withHandlers;
  var withProps = require('recompose').withProps;
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  const { curry, isNil } = require('lodash/fp');
  var action = compose(
    withProps(function(props) {
      var reportPartSelectionStore = new ReportPartSelectionStore();

      return {
        reportPartSelectionStore: reportPartSelectionStore,
        showReportPart: props.type === ReportPartSelectionConstants.TYPE.REPORT_PART
      };
    }),
    withState('isShowResult', 'showResult', false),
    withHandlers({
      onBack: curry(function(props, e) {
        props.showResult(false);
      }),
      onOK: curry(function(props, e) {
        var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;
        var returnObject = props.showReportPart
          ? reportPartSelection.selectedReportPart
          : reportPartSelection.selectedReport;

        props.onAccept();
        props.onChange({
          report: reportPartSelection.selectedReport,
          reportPart: reportPartSelection.selectedReportPart
        });
      }),
      checkDisabledAcceptButton: function(props) {
        return function() {
          var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;

          return props.showReportPart
            ? isNil(reportPartSelection.selectedReportPart)
            : isNil(reportPartSelection.selectedReport);
        };
      }
    })
  );

  module.exports = action;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartSelectionPopupAction.js